import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { InvoiceMasterData } from "../../../apis/models/InvoiceMasterRequest";
import CheckboxGroup from "../../core/CheckboxGroup";
import styles from "./index.module.scss";

const InvoiceDownloadDialog: React.FC<InvoiceDownloadDialogProps> = (props: InvoiceDownloadDialogProps) => {
  const { open, targetInvoice, onClose, onDownload } = props;
  const [pdf, setPdf] = React.useState<boolean>(true);
  const [excel, setExcel] = React.useState<boolean>(true);

  const invoicePeriod = React.useMemo(() => {
    return `${format(new Date(targetInvoice.from), "yyyy/MM/dd")} ～ ${format(new Date(targetInvoice.to), "yyyy/MM/dd")}`
  }, [targetInvoice])

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="lg">
      <DialogTitle sx={{ fontWeight: 700, fontSize: "24px", padding: "40px 40px 60px" }}>
        {targetInvoice.brand?.brandName ?? ""} - 請求書ダウンロード
      </DialogTitle>
      <DialogContent sx={{ padding: "0 40px 24px" }}>
        <div className={styles.descriptions}>
          <span>請求期間：</span>
          <span>{invoicePeriod}</span>
        </div>
        <div className={styles.checbox_group}>
            <div>請求ステータス</div>
            <div>
                <CheckboxGroup checked={excel} onChange={() => setExcel(!excel)} label="Excel"/>
                <CheckboxGroup checked={pdf} onChange={() => setPdf(!pdf)} label="PDF"/>
            </div>
        </div>
        <div className={styles.functions}>
          <Button variant="outlined" onClick={() => onClose()}>キャンセル</Button>
          <Button variant="contained" onClick={() => onDownload(targetInvoice, pdf, excel)}>ダウンロード</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default InvoiceDownloadDialog;

export type InvoiceDownloadDialogProps = {
  open: boolean,
  targetInvoice: InvoiceMasterData,
  onClose: () => void,
  onDownload: (targetInvoice: InvoiceMasterData, pdf: boolean, excel: boolean) => void
}